import {Emitter} from '../../../../shared/base/General';

let cast, chrome;

/**
 * @name CastWrapper
 * @extends Emitter
 *
 * @property {cast.framework.RemotePlayer} player
 * @property {cast.framework.RemotePlayerController} playerController
 */
class CastWrapper extends Emitter {
	constructor() {
		super(...arguments);

		this.loadPromise = new Promise((accept, reject) => {
			this.loadPromiseAccept = accept;
		});

		this.context = null;
		this.session = null;
		this.player = null;
		this.playerController = null;
		this.available = false;
	}

	load() {
		window['__onGCastApiAvailable'] = (isAvailable) => {
			if (isAvailable) {
				this.setup();

				this.loadPromiseAccept();
			} else {
				console.error('Cast not available')
			}
		};

		const script = document.createElement('script');
		script.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';

		document.head.appendChild(script);
	}

	setup() {
		cast = window.cast;
		chrome = window.chrome;

		const context = cast.framework.CastContext.getInstance();

		context.setOptions({
			receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID
		});

		this.context = context;
		this.session = context.getCurrentSession();
		if (this.session) {
			this.emit('connect');
		}
		this.createPlayer();

		this.available = context.getCastState() !== cast.framework.CastState.NO_DEVICES_AVAILABLE;
		if (this.available) {
			this.emit('available');
		} else {
			this.emit('unavailable');
		}

		/// Events
		window.addEventListener('beforeunload', () => {
			this.endSession();
		});

		context.addEventListener(
			cast.framework.CastContextEventType.SESSION_STATE_CHANGED,

			(event) => {
				switch (event.sessionState) {
					case cast.framework.SessionState.SESSION_STARTED:
					case cast.framework.SessionState.SESSION_RESUMED:
						break;
					case cast.framework.SessionState.SESSION_ENDED:
						console.log('CastContext: CastSession disconnected');
						this.endSession();
						break;
				}
			}
		);

		context.addEventListener(
			cast.framework.CastContextEventType.CAST_STATE_CHANGED,

			(event) => {
				switch (event.castState) {
					case cast.framework.CastState.NO_DEVICES_AVAILABLE:
						this.available = false;
						this.emit('unavailable');
						break;
					case cast.framework.CastState.NOT_CONNECTED:
					case cast.framework.CastState.CONNECTING:
					case cast.framework.CastState.CONNECTED:
						this.available = true;
						this.emit('available');
						break;
				}
			}
		);
	}

	async requestSession() {
		await this.loadPromise;

		await this.context.requestSession();
		this.session = this.context.getCurrentSession();

		if (this.session) {
			this.emit('connect');
		}
	}

	endSession() {
		this.context.endCurrentSession(true);
		this.session = null;
		this.player = null;
		this.playerController = null;

		this.emit('disconnect');
	}


	// Media
	async loadMedia(url, type = 'video/mp4') {
		if (!this.session) await this.requestSession();
		if (!this.session) {
			console.error('no session available');
			return;
		}

		const mediaInfo = new chrome.cast.media.MediaInfo(encodeURI(url), type);
		const request = new chrome.cast.media.LoadRequest(mediaInfo);

		try {
			await this.session.loadMedia(request);

			return true;
		} catch (e) {
			console.error(e);

			return false;
		}
	}

	createPlayer() {
		this.player = new cast.framework.RemotePlayer();
		this.playerController = new cast.framework.RemotePlayerController(this.player);

		// Time
		this.playerController.addEventListener(
			cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED,
			() => {
				this.emit('timeupdate', this.player.currentTime);
			}
		);

		// Pause
		this.playerController.addEventListener(
			cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED,
			() => {
				if (this.player.isPaused) {
					this.emit('pause');
				} else {
					this.emit('play');
				}
			}
		);

		// Pause
		this.playerController.addEventListener(
			cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED,
			() => {
				switch (this.player.playerState) {
					case chrome.cast.media.PlayerState.PLAYING:
						this.emit('play');
						break;
					case chrome.cast.media.PlayerState.PAUSED:
						this.emit('pause');
						break;
					case chrome.cast.media.PlayerState.BUFFERING:
						this.emit('waiting');
						break;
					case chrome.cast.media.PlayerState.IDLE:
						this.emit('stalled');
						break;
				}
			}
		);
	}

	play() {
		if (
			this.player &&
			this.player.isPaused
		) {
			this.playerController.playOrPause();
		}
	}

	pause() {
		if (
			this.player &&
			this.player.canPause &&
			!this.player.isPaused
		) {
			this.playerController.playOrPause();
		}
	}

	seek(time) {
		if (
			this.player &&
			this.player.canSeek
		) {
			this.player.currentTime = time;
			this.playerController.seek();
		}
	}
}

const castWrapper = new CastWrapper();
castWrapper.load();

export default castWrapper;